export const answerDecoder = (answer, answer_list) => {
  let result = [];
  const page_answers = answer_list;
  switch (Object.keys(answer)[0]) {
    case 'multiple_answer':
      let arr = [];
      for (let i in answer.multiple_answer) {
        if (answer.multiple_answer[i] == true) {
          let search_result = page_answers.find(function (element) {
            return element[0] == i;
          });
          arr.push(search_result);
        }
      }
      return arr;

    case 'single_answer':
      return [page_answers[answer.single_answer]];
    case 'text_answer':
      return [answer.text_answer];
    case 'number_answer':
      return answer.number_answer ? [parseFloat(answer.number_answer)] : [];
    case 'map_answer':
      return [
        ['lat', answer.map_answer.lat],
        ['lng', answer.map_answer.lng],
      ];
    case 'drawable_map_answer':
      return [answer.drawable_map_answer];
    case 'calendar_answer':
      return [answer.calendar_answer];
    case 'single_answer':
      return [page_answers[answer.single_answer]];
    case 'single_select':
      return [
        page_answers.find(function (element) {
          return element[1] == answer.single_select;
        }),
      ];
    case 'upload_media':
    case 'file_upload':           // v2 alias
      return [answer.upload_media ?? answer.file_upload];
    case 'list_input':
    case 'list':                  // v2 alias
      result = ['list'];
      for (let i in (answer.list_input ?? answer.list)) {
        result.push((answer.list_input ?? answer.list)[i]);
      }
      return result;
    case 'esignature_answer':
      return [answer.esignature_answer];
    case 'image_annotation_answer':
      return [answer.image_annotation_answer];
    case 'address_answer':
      return [answer.address_answer];
    case 'table_answer':
      return answer.table_answer;
    case 'repeatable_sections_answer':
      return answer.repeatable_sections_answer;
    default:
      return [answer];
  }
};
